import { Component, OnInit, ViewChild, HostListener } from '@angular/core';
import { HttpHeaders } from '@angular/common/http';
import { HttpClient } from '@angular/common/http';
import { URLSearchParams } from '@angular/http';
import {MatSnackBar} from '@angular/material';
import { DomSanitizer } from '@angular/platform-browser';

//Third Party imports
import * as d3 from 'd3'; 
import * as d3Selection from 'd3-selection';
import * as transition from 'd3-transition'
import * as _ from "lodash";

//User imports
import { oAuth } from '../providers/oAuth';
import { Pharmacies } from '../dataObjects/Pharmacies';
import { DashboardScript, DashboardTopFive, DashboardBargraph, DashboardLineGraph } from '../dataObjects/DashboardScript';
import { DashboardDonut } from '../dataObjects/DashboardDonut';
import { DashboardDonutRequest } from '../dataObjects/DashboardDonut';
import { GlobalVariable } from '../common/global';

@Component({
  selector: 'app-dash',
  templateUrl: './dash.component.html',
  styleUrls: ['./dash.component.css']
})
export class DashComponent implements OnInit {

    GenLineChartWidth: number
    GenLineChartHeight: number

    GenBarGraphWidth: number
    GenBarGraphHeight: number

    GenDonutWidth: number
    GenDonutHeight: number
    GenDonutArcMod: number

    pharms: [Pharmacies]
    PharmaciesSelectedValue: number

    StartDate: Date
    EndDate: Date

    repotingPeroidSelected: number

    ScriptdisplayedColumns = ['colReportName', 'colToday', 'col7Days', 'col30Days'];
    TopFivedisplayedColumns = ['colDrugName', 'colTotalScripts', 'colTotalRev'];
    ScriptRequest: DashboardScript[]
    TopFiveDrugs: DashboardTopFive[]
    Bargraph: DashboardBargraph[]
    LineGraph: DashboardLineGraph[]

    DonutGenericVsBrand: DashboardDonut[]
    DonutTopFive: DashboardDonut[]
    DonutRefillVsNew: DashboardDonut[]

    lineGraphOption: number
  barGraphOption: number

  TopFiveSelectRev: number
  TopFiveSelectScript: number

    DonutRefillVsNewSvg: any//d3Selection.Selection<BaseType, {}, HTMLElement, any>
    DonutGenericSvg: any
    BarGraphSvg: any
    LineGraphSvg: any

   LastWeek: Date
   LastWeek7: Date
   LastWeek30: Date
   LastWeek60: Date

    constructor(private http: HttpClient) { }

    ngOnInit() {

        this.DonutRefillVsNewSvg = null
        this.DonutGenericSvg = null

        this.lineGraphOption = 1
        this.repotingPeroidSelected = 0
        this.EndDate = new Date()
        this.StartDate = new Date()
        this.StartDate.setDate(new Date().getDate() - 1)
        this.LastWeek = new Date(new Date().getTime() - (1000 * 60 * 60 * 24 * 7));
        this.LastWeek7 = new Date(new Date().getTime() - (1000 * 60 * 60 * 24 * 14));
        this.LastWeek30 = new Date(new Date().getTime() - (1000 * 60 * 60 * 24 * 30));
        this.LastWeek60 = new Date(new Date().getTime() - (1000 * 60 * 60 * 24 * 60));
      this.barGraphOption = 1
      this.TopFiveSelectScript = 950;
      this.TopFiveSelectRev = 700;

        this.GenLineChartWidth = window.innerWidth
        this.GenLineChartHeight = (window.innerHeight * .19)

        var margin = { top: 20, right: 20, bottom: 30, left: 85 },
            width = (window.innerWidth * .35) - margin.left - margin.right,
            height = (window.innerHeight * .40) - margin.top - margin.bottom;

        this.GenBarGraphWidth = width
        this.GenBarGraphHeight = height

        margin = { top: 0, right: 0, bottom: 0, left: 0 },
            width = (window.innerWidth * .30) - margin.left - margin.right,
            height = (window.innerHeight * .20) - margin.top - margin.bottom;

      this.GenDonutWidth = width
      this.GenDonutHeight = height

      this.PharmaciesSelectedValue = 0;
      this.PopPharmList();
      this.PopListSummary()
      this.PopLineGraph()
      this.PopListBarGraph()
      this.PopDonutGenericVsBrand()
      this.PopRefillVsNew()
      this.PopListTopFiveDrugsScript()
    }

  @HostListener('window:resize', ['$event'])
  onResize(event) {

      event.target.innerWidth;

      var margin = { top: 20, right: 20, bottom: 30, left: 50 },
          width = window.innerWidth - margin.left - margin.right,
          height = (window.innerHeight * .19) - margin.top - margin.bottom;

      this.GenLineChartWidth = width
      this.GenLineChartHeight = height

      margin = { top: 20, right: 20, bottom: 30, left: 85 },
          width = (window.innerWidth * .35) - margin.left - margin.right,
          height = (window.innerHeight * .40) - margin.top - margin.bottom;

      this.GenBarGraphWidth = width
      this.GenBarGraphHeight = height

      margin = { top: 0, right: 0, bottom: 0, left: 0 },
          width = (window.innerWidth * .30) - margin.left - margin.right,
          height = (window.innerHeight * .20) - margin.top - margin.bottom;

      this.GenDonutWidth = width
      this.GenDonutHeight = height
  }

  TopDrugScriptClick(): void {

    this.PopListTopFiveDrugsScript();

    this.TopFiveSelectRev = 700;
    this.TopFiveSelectScript = 950;
  }

  TopDrugRevClick(): void {

    this.PopListTopFiveDrugs();

    this.TopFiveSelectRev = 950;
    this.TopFiveSelectScript = 700;
  }

  PopPharmList(): void {

      const token = JSON.parse(sessionStorage.getItem('data'));
      const tokenPayload = <oAuth>(token);

      let options = {
          headers: new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded').set('Authorization', 'Bearer ' + tokenPayload.access_token.toString())
      };

      this.http.get(GlobalVariable.BASE_API_URL + "/api/RxqOnePharmacies", options)
          .subscribe(
          (response) => {
              const resp = <[Pharmacies]>response
              this.pharms = resp;
          },
          (err) => {
              /* this function is executed when there's an ERROR */
              console.log("ERROR: " + err);
          },
          () => {
              /* this function is executed when the observable ends (completes) its stream */
              //console.log("COMPLETED");
          }
          );
  }

  PharmChanged(): void {

    if (this.TopFiveSelectScript == 950) {
      this.PopListTopFiveDrugsScript()
    }
    else {
      this.PopListTopFiveDrugs()
    }

      this.PopLineGraph()
      this.PopDonutGenericVsBrand()
      this.PopRefillVsNew()
      this.PopListSummary()
  }

  DatesChanged() {
      if (this.repotingPeroidSelected == 0) {
          this.EndDate = new Date()
          this.StartDate = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate() - 1)
      }
      if (this.repotingPeroidSelected == 1) {
          this.EndDate = new Date()
          this.StartDate = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate() - 7)
      }
      if (this.repotingPeroidSelected == 2) {
          this.EndDate = new Date()
          this.StartDate = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate() - 30)
      }
      this.PopLineGraph() 
      this.PopDonutGenericVsBrand()
      this.PopRefillVsNew()

    if (this.TopFiveSelectScript == 950) {
      this.PopListTopFiveDrugsScript()
    }
    else {
      this.PopListTopFiveDrugs()
    }

      this.PopListBarGraph()
  }
  setDate(date: any) {
    var s: String = date.toLocaleString();
    s = s.split(",")[0];
    return s;
  }

  PopLineGraph() {

      // Request for Print Codes
      const token = JSON.parse(sessionStorage.getItem('data'));
      const tokenPayload = <oAuth>(token);

      let options = {
          headers: new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded').set('Authorization', 'Bearer ' + tokenPayload.access_token.toString())
      };

      let DashboardDonutRequest: DashboardDonutRequest = {
          Pharmacy_Id: this.PharmaciesSelectedValue.toString(),
          StartDate: this.StartDate,
          EndDate: this.EndDate
      }
      if (DashboardDonutRequest.StartDate)
      DashboardDonutRequest.StartDate = this.setDate(DashboardDonutRequest.StartDate);
  if (DashboardDonutRequest.EndDate)
      DashboardDonutRequest.EndDate = this.setDate(DashboardDonutRequest.EndDate);

      var body = JSON.stringify(DashboardDonutRequest)

      //console.log(this.StartDate)
      //console.log(this.EndDate)

      this.http.post(GlobalVariable.BASE_API_URL + "/api/RxqOneScriptsByPharm", body.toString(), options)
          .subscribe(
          (response) => {
              const resp = <DashboardLineGraph[]>response
              this.LineGraph = resp;

              var svg = d3.select("#LineGraph").transition()

              if (svg.select(".line").empty() == true) {
                  this.GenLineChart();
              }
              else {
                  this.RedrawLineGraph();
              }
              
          },
          (err) => {
              /* this function is executed when there's an ERROR */
          },
          () => {
              /* this function is executed when the observable ends (completes) its stream */
              //this.openSnackBar("Set Batches has completed.", "OK");
          }
          );
  }

  PopListBarGraph() {

      // Request for Print Codes
      const token = JSON.parse(sessionStorage.getItem('data'));
      const tokenPayload = <oAuth>(token);

      let options = {
          headers: new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded').set('Authorization', 'Bearer ' + tokenPayload.access_token.toString())
      };

      let DashboardDonutRequest: DashboardDonutRequest = {
          Pharmacy_Id: '0',
          StartDate: this.StartDate,
          EndDate: this.EndDate
      }
      if (DashboardDonutRequest.StartDate)
      DashboardDonutRequest.StartDate = this.setDate(DashboardDonutRequest.StartDate);
  if (DashboardDonutRequest.EndDate)
      DashboardDonutRequest.EndDate = this.setDate(DashboardDonutRequest.EndDate);


      var body = JSON.stringify(DashboardDonutRequest)

      this.http.post(GlobalVariable.BASE_API_URL + "/api/RxqOneScriptsByStore", body.toString(), options)
          .subscribe(
          (response) => {
              const resp = <DashboardBargraph[]>response

              this.Bargraph = [];
              this.Bargraph = resp;

              var svg = d3.select("#BarsGraph").transition()

              if (svg.select(".bar").empty() == true) {
                  this.GenBarGraph(this.Bargraph);
              }
              else {
                  this.RedrawBarGraph();
              }
          },
          (err) => {
              /* this function is executed when there's an ERROR */
          },
          () => {
              /* this function is executed when the observable ends (completes) its stream */
              //this.openSnackBar("Set Batches has completed.", "OK");
          }
          );
  }

  PopListTopFiveDrugs() {

      // Request for Print Codes
      const token = JSON.parse(sessionStorage.getItem('data'));
      const tokenPayload = <oAuth>(token);

      let options = {
          headers: new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded').set('Authorization', 'Bearer ' + tokenPayload.access_token.toString())
      };

      let DashboardDonutRequest: DashboardDonutRequest = {
          Pharmacy_Id: this.PharmaciesSelectedValue.toString(),
          StartDate: this.StartDate,
          EndDate: this.EndDate
      }
      if (DashboardDonutRequest.StartDate)
      DashboardDonutRequest.StartDate = this.setDate(DashboardDonutRequest.StartDate);
  if (DashboardDonutRequest.EndDate)
      DashboardDonutRequest.EndDate = this.setDate(DashboardDonutRequest.EndDate);


      var body = JSON.stringify(DashboardDonutRequest)

      this.http.post(GlobalVariable.BASE_API_URL + "/api/RxqOneTopFiveDrugs", body.toString(), options)
          .subscribe(
          (response) => {
              const resp = <DashboardTopFive[]>response
              this.TopFiveDrugs = resp;
          },
          (err) => {
              /* this function is executed when there's an ERROR */
          },
          () => {
              /* this function is executed when the observable ends (completes) its stream */
              //this.openSnackBar("Set Batches has completed.", "OK");
          }
          );
  }

  PopListTopFiveDrugsScript() {

    // Request for Print Codes
    const token = JSON.parse(sessionStorage.getItem('data'));
    const tokenPayload = <oAuth>(token);

    let options = {
      headers: new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded').set('Authorization', 'Bearer ' + tokenPayload.access_token.toString())
    };

    let DashboardDonutRequest: DashboardDonutRequest = {
      Pharmacy_Id: this.PharmaciesSelectedValue.toString(),
      StartDate: this.StartDate,
      EndDate: this.EndDate
    }
    if (DashboardDonutRequest.StartDate)
    DashboardDonutRequest.StartDate = this.setDate(DashboardDonutRequest.StartDate);
if (DashboardDonutRequest.EndDate)
    DashboardDonutRequest.EndDate = this.setDate(DashboardDonutRequest.EndDate);


    var body = JSON.stringify(DashboardDonutRequest)

    this.http.post(GlobalVariable.BASE_API_URL + "/api/RxqOneTopFiveDrugsScript", body.toString(), options)
      .subscribe(
        (response) => {
          const resp = <DashboardTopFive[]>response
          this.TopFiveDrugs = resp;
          console.log(resp);
        },
        (err) => {
          /* this function is executed when there's an ERROR */
        },
        () => {
          /* this function is executed when the observable ends (completes) its stream */
          //this.openSnackBar("Set Batches has completed.", "OK");
        }
      );
  }

  PopListSummary() {

      // Request for Print Codes
      const token = JSON.parse(sessionStorage.getItem('data'));
      const tokenPayload = <oAuth>(token);

      let options = {
          headers: new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded').set('Authorization', 'Bearer ' + tokenPayload.access_token.toString())
      };

      let DashboardDonutRequest: DashboardDonutRequest = {
          Pharmacy_Id: this.PharmaciesSelectedValue.toString(),
          StartDate: this.StartDate,
          EndDate: this.EndDate
      }
      if (DashboardDonutRequest.StartDate)
      DashboardDonutRequest.StartDate = this.setDate(DashboardDonutRequest.StartDate);
  if (DashboardDonutRequest.EndDate)
      DashboardDonutRequest.EndDate = this.setDate(DashboardDonutRequest.EndDate);

      var body = JSON.stringify(DashboardDonutRequest)

      this.http.post(GlobalVariable.BASE_API_URL + "/api/RxqOneSummary", body.toString(), options)
          .subscribe(
          (response) => {
              const resp = <DashboardScript[]>response
              this.ScriptRequest = resp;
          },
          (err) => {
              /* this function is executed when there's an ERROR */
          },
          () => {
              /* this function is executed when the observable ends (completes) its stream */
              //this.openSnackBar("Set Batches has completed.", "OK");
          }
          );
  }

  PopDonutGenericVsBrand() {

      // Request for Print Codes
      const token = JSON.parse(sessionStorage.getItem('data'));
      const tokenPayload = <oAuth>(token);

      let options = {
          headers: new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded').set('Authorization', 'Bearer ' + tokenPayload.access_token.toString())
      };

      let DashboardDonutRequest: DashboardDonutRequest = {
          Pharmacy_Id: this.PharmaciesSelectedValue.toString(),
          StartDate: this.StartDate,
          EndDate: this.EndDate
      }
      if (DashboardDonutRequest.StartDate)
      DashboardDonutRequest.StartDate = this.setDate(DashboardDonutRequest.StartDate);
  if (DashboardDonutRequest.EndDate)
      DashboardDonutRequest.EndDate = this.setDate(DashboardDonutRequest.EndDate);

      var body = JSON.stringify(DashboardDonutRequest)

      this.http.post(GlobalVariable.BASE_API_URL + "/api/RxqOneGenericVsBrand", body.toString(), options)
          .subscribe(
          (response) => {
              const resp = <DashboardDonut[]> response
              this.DonutGenericVsBrand = resp;
              //this.GenDonutGenericVsBrand()

              // set the dimensions and margins of the graph
              var margin = { top: 0, right: 0, bottom: 0, left: 0 },
                  width = (window.innerWidth * .30) - margin.left - margin.right,
                  height = (window.innerHeight * .20) - margin.top - margin.bottom;
              //console.log(this.DonutRefillVsNewSvg)
              if (this.DonutGenericSvg == null) {

                  this.DonutGenericSvg = d3.select("#GenericVsBrand").append("svg")
                      .attr("width", width)
                      .attr("height", height)
                      .append("g")
                      .attr("transform", "translate(" + (width / 2 + 65) + "," + height / 2 + ")");

                  this.DonutGenericSvg.append("text")
                    .attr("x", (-width / 2))
                    .attr("y", (-height / 3))
                      .attr("text-anchor", "middle")
                      .style("font-size", "16px")
                      .style("text-decoration", "underline")
                    .text("Brand vs Generic");

              }

          },
          (err) => {
              /* this function is executed when there's an ERROR */
          },
          () => {
              this.UpdateDonut(this.DonutGenericVsBrand, this.DonutGenericSvg)
          }
          );
  }

  PopRefillVsNew() {

      // Request for Print Codes
      const token = JSON.parse(sessionStorage.getItem('data'));
      const tokenPayload = <oAuth>(token);

      let options = {
          headers: new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded').set('Authorization', 'Bearer ' + tokenPayload.access_token.toString())
      };

      let DashboardDonutRequest: DashboardDonutRequest = {
          Pharmacy_Id: this.PharmaciesSelectedValue.toString(),
          StartDate: this.StartDate,
          EndDate: this.EndDate
      }
      if (DashboardDonutRequest.StartDate)
      DashboardDonutRequest.StartDate = this.setDate(DashboardDonutRequest.StartDate);
  if (DashboardDonutRequest.EndDate)
      DashboardDonutRequest.EndDate = this.setDate(DashboardDonutRequest.EndDate);

      var body = JSON.stringify(DashboardDonutRequest)

      this.http.post(GlobalVariable.BASE_API_URL + "/api/RxqOneRefillVsNew", body.toString(), options)
          .subscribe(
          (response) => {
              const resp = <DashboardDonut[]>response
              this.DonutRefillVsNew = resp;
              //this.GenDonutRefillNew()


              // set the dimensions and margins of the graph
              var margin = { top: 0, right: 0, bottom: 0, left: 0 },
                  width = (window.innerWidth * .30) - margin.left - margin.right,
                  height = (window.innerHeight * .20) - margin.top - margin.bottom;
              //console.log(this.DonutRefillVsNewSvg)
              if (this.DonutRefillVsNewSvg == null) {

                  this.DonutRefillVsNewSvg = d3.select("#RefillNew").append("svg")
                      .attr("width", width)
                      .attr("height", height)
                      .append("g")
                      .attr("transform", "translate(" + (width / 2 + 65) + "," + height / 2 + ")");

                  this.DonutRefillVsNewSvg.append("text")
                    .attr("x", (-width / 2))
                    .attr("y", (-height / 3))
                      .attr("text-anchor", "middle")
                      .style("font-size", "16px")
                      .style("text-decoration", "underline")
                      .text("Refill vs New");
              }
          },
          (err) => {
              /* this function is executed when there's an ERROR */
          },
          () => {

              this.UpdateDonut(this.DonutRefillVsNew, this.DonutRefillVsNewSvg)
          }
          );
  }

  GenLineChart() {

      var data: DashboardLineGraph[] = this.LineGraph

      // set the dimensions and margins of the graph
      var margin = { top: 20, right: 20, bottom: 30, left: 50 },
          width = window.innerWidth - margin.left - margin.right,
          height = (window.innerHeight * .19) - margin.top - margin.bottom;

      width = this.GenLineChartWidth;
      height = this.GenLineChartHeight;

      // parse the date / time
      var parseTime = d3.timeParse("%d-%b-%y");

      // set the ranges
      var x = d3.scaleTime().range([0, width]);
      var y = d3.scaleLinear().range([height, 0]);

      // define the line
      var valueline = d3.line<DashboardLineGraph>()
          .x(function (d: DashboardLineGraph) { return x(new Date(d.DateObj)); })
          .y(function (d: DashboardLineGraph) { return y(d.TotalScripts); });
      // define the line
      //var valueline2 = d3.line()
      //    .x(function (d) { return x(d.Date); })
      //    .y(function (d) { return y(d.Exports); });

      // append the svg obgect to the body of the page
      // appends a 'group' element to 'svg'
      // moves the 'group' element to the top left margin
      this.LineGraphSvg = d3.select("#LineGraph").append("svg")
          //.attr("width", width + margin.left + margin.right)
          //.attr("height", height + margin.top + margin.bottom)
          .classed("svg-container", true)
          .attr("preserveAspectRatio", "xMinYMin meet")
          .attr("viewBox", "0 0 " + (width + margin.left + margin.right) + " " + (height + margin.top + margin.bottom))
          .append("g")
          .attr("class", "LineGraph")
          .attr("transform",
          "translate(" + margin.left + "," + margin.top + ")");

      function draw(data: DashboardLineGraph[], svg) {

          var data = data;

          // format the data
          data.forEach(function (d: DashboardLineGraph) {
              d.DateObj = d.DateObj;
              d.TotalScripts = +d.TotalScripts;
          });

          // sort years ascending
          data.sort(function (a, b) {
              return (new Date(a.DateObj).getDate() + new Date(a.DateObj).getTime()) - (new Date(b.DateObj).getDate() + new Date(b.DateObj).getTime());
          })

          // Scale the range of the data
          x.domain(d3.extent(data, function (d) { return new Date(d.DateObj); }));
          y.domain([0, d3.max(data, function (d) {
              return Math.max(d.TotalScripts);
          })]);

          // define the area
          var area = d3.area<DashboardLineGraph>()
              .x(function (d: DashboardLineGraph) { return x(new Date(d.DateObj)); })
              .y0(height)
              .y1(function (d: DashboardLineGraph) { return y(d.TotalScripts); });

          // add the area
          svg.append("path")
              .data([data])
              .attr("class", "area")
              .style("fill","#a6cee3")
              .attr("d", area);

          // Add the valueline path.
          svg.append("path")
              .data([data])
              .attr("class", "line")
              .attr("d", valueline)
              .style("fill", "none")
              .style("stroke", "steelblue")
              .style("stroke", "2px");

          // Add the X Axis
          svg.append("g")
              .attr("transform", "translate(0," + height + ")")
              .attr("class", "xaxis")
              .call(d3.axisBottom(x));

          // Add the Y Axis
          svg.append("g")
              .attr("class", "yaxis")
              .call(d3.axisLeft(y));
      }

      // trigger render
      draw(data, this.LineGraphSvg);
      //}
  }

  RedrawLineGraph() {
      var data = this.LineGraph

      //console.log(data)

      //lineGraphOption
      // Set the dimensions of the canvas / graph
      var margin = { top: 30, right: 20, bottom: 30, left: 50 },
          width = 600 - margin.left - margin.right,
          height = 270 - margin.top - margin.bottom;

      width = this.GenLineChartWidth;
      height = this.GenLineChartHeight;

      var parseTime = d3.timeParse("%d-%b-%y");

      // set the ranges
      var x = d3.scaleTime().range([0, width]);
      var y = d3.scaleLinear().range([height, 0]);


      if (this.lineGraphOption == 1) {
          var valueline = d3.line<DashboardLineGraph>()
              .x(function (d: DashboardLineGraph) { return x(new Date(d.DateObj)); })
              .y(function (d: DashboardLineGraph) { return y(d.TotalScripts); });

          // Scale the range of the data
          x.domain(d3.extent(data, function (d: DashboardLineGraph) { return new Date(d.DateObj); }));
          y.domain([0, d3.max(data, function (d: DashboardLineGraph) {
              return Math.max(d.TotalScripts);
          })]);


          // format the data
          data.forEach(function (d: DashboardLineGraph) {
              d.DateObj = d.DateObj;
              d.TotalScripts = +d.TotalScripts;
          });

          // define the area
          var area = d3.area<DashboardLineGraph>()
              .x(function (d: DashboardLineGraph) { return x(new Date(d.DateObj)); })
              .y0(height)
              .y1(function (d: DashboardLineGraph) { return y(d.TotalScripts); });

      }

      if (this.lineGraphOption == 2) {
          var valueline = d3.line<DashboardLineGraph>()
              .x(function (d: DashboardLineGraph) { return x(new Date(d.DateObj)); })
              .y(function (d: DashboardLineGraph) { return y(d.TotalRev); });

          // Scale the range of the data
          x.domain(d3.extent(data, function (d) { return new Date(d.DateObj); }));
          y.domain([0, d3.max(data, function (d) {
              return Math.max(d.TotalRev);
          })]);


          // format the data
          data.forEach(function (d: DashboardLineGraph) {
              d.DateObj = d.DateObj;
              d.TotalRev = +d.TotalRev;
          });

          // define the area
          var area = d3.area<DashboardLineGraph>()
              .x(function (d: DashboardLineGraph) { return x(new Date(d.DateObj)); })
              .y0(height)
              .y1(function (d: DashboardLineGraph) { return y(d.TotalRev); });
      }

      // sort years ascending
      data.sort(function (a, b) {
          return (new Date(a.DateObj).getDate() + new Date(a.DateObj).getTime()) - (new Date(b.DateObj).getDate() + new Date(b.DateObj).getTime());
      })

      var svg = d3.select("#LineGraph").transition()

      // Make the changes
      svg.select(".line")   // change the line
          .duration(750)
          .attr("d", valueline(data))

      svg.select(".area")   // change the line
          .duration(750)
          .attr("d", area(data))

      this.LineGraphSvg.select(".xaxis").transition()
          .duration(300)
          .call(d3.axisBottom(x));

      //svg.select(".xaxis") // change the x axis
      //    .attr("transform", "translate(0," + height + ")")
      //    .duration(750)
      //    .call(d3.axisBottom(x));
      this.LineGraphSvg.select(".yaxis").transition()
          .duration(300)
          .call(d3.axisLeft(y));

      //this.LineGraphSvg.select(".yaxis") // change the y axis
      //    .duration(750)
      //    .call(d3.axisLeft(y));

  }

  GenBarGraph(jsonData: DashboardBargraph[]) {

      // set the dimensions and margins of the graph
      var margin = { top: 20, right: 20, bottom: 30, left: 85 },
          width = (window.innerWidth * .35) - margin.left - margin.right,
          height = (window.innerHeight * .40) - margin.top - margin.bottom;

       width = this.GenBarGraphWidth 
       height = this.GenBarGraphHeight

       this.BarGraphSvg = d3.select("#BarsGraph").append("svg")
           .classed("svg-container", true)
           .attr("preserveAspectRatio", "xMinYMin meet")
           .attr("viewBox", "0 0 " + (width + margin.left + margin.right) + " " + (height + margin.top + margin.bottom))

      var tooltip = d3.select("BarsGraph").append("div").attr("class", "toolTip");

      var x = d3.scaleLinear().range([0, width]);
      var y = d3.scaleBand().range([height, 0]);

     //y.domain([0, d3.max(jsonData, function (d) { return d.value; })]);

      var g = this.BarGraphSvg.append("g")
          .attr("transform", "translate(" + margin.left + "," + margin.top + ")");

          jsonData.sort(function (a, b) { return a.value - b.value; });

          x.domain([0, d3.max(jsonData, function (d) { return d.value; })]);
          y.domain(jsonData.map(function (d) { return d.area; })).padding(0.1);


          g.append("g")
              .attr("class", "xaxis")
              .attr("transform", "translate(0," + height + ")")
              .call(d3.axisBottom(x).ticks(10).tickFormat(function (d:any) {
                  return d;
              }).tickSizeInner(-height));

          g.append("g")
              .attr("class", "yaxis")
              .call(d3.axisLeft(y));

          g.selectAll(".bar")
              .data(jsonData)
              .enter().append("rect")
              .attr("class", "bar")
              .attr("x", 0)
              .attr("height", y.bandwidth())
              .attr("y", function (d: DashboardBargraph) { return y(d.area); })
              .attr("width", function (d: DashboardBargraph) { return x(d.value); })
              .style("fill","steelblue")
  }

  RedrawBarGraph() {

      var data = this.Bargraph
      var Passedsvg = this.BarGraphSvg

      var margin = { top: 20, right: 20, bottom: 30, left: 85 },
          width = (window.innerWidth * .35) - margin.left - margin.right,
          height = (window.innerHeight * .40) - margin.top - margin.bottom;

      width = this.GenBarGraphWidth
      height = this.GenBarGraphHeight

      var x = d3.scaleLinear().range([0, width]);
      var y = d3.scaleBand().range([height, 0]);

      var g = this.BarGraphSvg.append("g")
          .attr("transform", "translate(" + margin.left + "," + margin.top + ")");

      if (this.barGraphOption == 1) {
          x.domain([0, d3.max(data, function (d) {
              return d.value;
          })]);
          var bars = g.selectAll(".bar").data(data, function (d) { return d.value; }) 

          y.domain(data.map(function (d) { return d.area; })).padding(0.1);

          Passedsvg.select('.xaxis').transition().duration(300)
              .call(d3.axisBottom(x).ticks(10).tickFormat(function (d:any) {
                  return d;
              }).tickSizeInner(-height));
              //.call(d3.axisBottom(x).ticks(10).tickFormat(function (d) { return parseInt(d); }).tickSizeInner([-height]));

          Passedsvg.select(".yaxis").transition().duration(300).call(d3.axisLeft(y));

          bars.exit()
              .transition()
              .duration(300)
              .attr("x", x(0))
              .attr("height", height - x(0))
              .style('fill-opacity', 1e-6)
              .remove();

          bars.enter().append("rect")
              .attr("class", "bar")
              .attr("x", 0)
              .attr("height", y.bandwidth())
              .attr("y", function (d) { return y(d.area); })
              .attr("width", function (d) { return x(d.value); })
              .style("fill", "steelblue")

          bars.transition().duration(300).attr("x", function (d) { return x(d.value); })
              .attr("width", function (d) { return x(d.value); })
              .attr("y", function (d) { return y(d.frequency); })
              .attr("height", y.bandwidth())
      }

      if (this.barGraphOption == 2) {
          x.domain([0, d3.max(data, function (d) { return d.revValue; })]);
          var bars = g.selectAll(".bar").data(data, function (d) {
              return d.revValue;
          }) 

          y.domain(data.map(function (d) { return d.area; })).padding(0.1);

          Passedsvg.select('.xaxis').transition().duration(300)
              .call(d3.axisBottom(x).ticks(10).tickFormat(function (d: any) {
                  return d;
              }).tickSizeInner(-height));

          Passedsvg.select(".yaxis").transition().duration(300).call(d3.axisLeft(y));

          bars.exit()
              .transition()
              .duration(300)
              .attr("transform", "translate(" + margin.left + "," + margin.top + ")")
              .attr("x", x(0))
              .attr("height", height - x(0))
              .style('fill-opacity', 1e-6)
              .remove();

          bars.enter().append("rect")
              .attr("class", "bar")
              .attr("x", 0)
              .attr("height", y.bandwidth())
              .attr("y", function (d) { return y(d.area); })
              .attr("width", function (d) { return x(d.revValue); })
              .style("fill", "steelblue")

          bars.transition().duration(300).attr("x", function (d) { return x(d.value); })
              .attr("width", function (d) { return x(d.revValue); })
              .attr("y", function (d) { return y(d.frequency); })
              .attr("height", y.bandwidth())
      }
  }

  UpdateDonut(PassedData, Passedsvg) {

      var margin = { top: 0, right: 0, bottom: 0, left: 0 },
          width = (window.innerWidth * .30) - margin.left - margin.right,
          height = (window.innerHeight * .20) - margin.top - margin.bottom;

      var color = d3.scaleOrdinal(d3.schemePaired);

      var pie = d3.pie<DashboardDonut>()
          .sort(null)
          .value(function (d: DashboardDonut) { return d.Value });

      var arc = d3.arc()
          .innerRadius(.35 * height)
          .outerRadius(.45 * height);

      function update(data, svg) {

          //console.log(svg)

          var path = svg.selectAll(".arc")
              .data(pie(data))
              //.enter().append("g")
              .attr("class", "arc")

          var pathEnter = path.enter().append("path")
              .attr("fill", function (d) { return color(d.data.Value); })
              .attr("d", arc)
              .on("mouseover", function () {
                  tooltip.style("display", null);
              })
              .on("mousemove", function (d) {
                  tooltip.transition().duration(200)
                      .style("opacity", 0.9);
                  tooltip.select("div").html(d.data.Name + ": " + d.data.Value)
                      .style("position", "fixed")
                      .style("text-align", "center")
                      .style("width", "120px")
                      .style("height", "20px")
                      .style("padding", "2px")
                      .style("padding-top", "4px")
                      .style("font", "10px sans-serif")
                      .style("background", "#707070")
                      .style("color", "white")
                      .style("border", "0px")
                      .style("border-radius", "8px")
                      .style("left", (d3.event.pageX + 15) + "px")
                      .style("top", (d3.event.pageY - 28) + "px");
              })
              .on("mouseout", function () {
                  tooltip.style("display", "none")
              })

          var pathUpdate = path.attr("d", arc);

          

          // Store the displayed angles in _current.
          // Then, interpolate from _current to the new angles.
          // During the transition, _current is updated in-place by d3.interpolate.
          //function arcTween(a) {
          //    var i = d3.interpolate(this._current, a);
          //    this._current = i(0);
          //    return function (t) {
          //        return arc(i(t));
          //    };
          //}

          var tooltip = d3.select("body").append("div")
              .attr("class", "tooltip")
              .style("opacity", 0.5);

          tooltip.append("rect")
              .attr("width", 30)
              .attr("height", 20)
              .attr("fill", "#ffffff")
              .style("opacity", 0.5);

          tooltip.append("div")
              .attr("x", 15)
              .attr("dy", "1.2em")
              .style("text-anchor", "middle")
              .attr("font-size", "1.5em")
              .attr("font-weight", "bold");

          svg.selectAll('.legend').remove();

          //Legend
          var legendItemSize = 18
          var legendSpacing = 4
          
          var legend = svg
              .selectAll('.legend')
              .data(color.domain())
              .enter()
              .append('g')
              .attr('class', 'legend')
              .attr('transform', (d, i) => {
                  var height = legendItemSize + legendSpacing
                  var offset = height * color.domain().length / 2
                  var x = legendItemSize * -2;
                  var y = (i * height) - offset
                  return `translate(${x}, ${y})`
              })

          legend
              .append('rect')
              .attr('width', legendItemSize)
              .attr('height', legendItemSize)
              .style('fill', color);

          var total = d3.sum(data.map(function (d) {
              return d.Value;
          }));

          legend.append("text")
              .attr('x', legendItemSize + legendSpacing)
              .attr('y', legendItemSize - legendSpacing)

              .text(function (d) {                  
                  return (Math.round(1000 * d / total) / 10) + "%";                  
              });
      }

      update(PassedData, Passedsvg)
  }
}



// WEBPACK FOOTER //
// ./src/app/dash/dash.component.ts